import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { errorsCode } from '../Login.enums';
import { loggerInfo } from 'utils/infoLog';
import Analytics from 'helpers/analytics';
import { useToast } from '@welbe/web-design-system';

type AccountTypes = {
	email: string;
	password: string;
};

export const useSignUp = () => {
	const { toast } = useToast();
	const navigate = useNavigate();
	const [isLoading, setLoading] = useState<boolean>(false);
	const [hasError, setError] = useState<boolean>(false);
	const [hasErrorRegex, setErrorRegex] = useState<boolean>(false);
	const [confirmationPassword, setConfirmationPassword] = useState<string>('');
	const [account, setAccount] = useState<AccountTypes>({
		email: '',
		password: '',
	});

	const handleToast = (message?: string) => {
		toast.error(message || 'Rellena los campos marcados.');
	};

	const handleError = (code: any) => {
		const errorCode = JSON.parse(JSON.stringify(code))?.code;
		if (errorCode) {
			handleToast(
				errorsCode[errorCode] ??
					'Hubo un error al intentar realizar esta acción.',
			);
		} else {
			handleToast('Hubo un error al intentar realizar esta acción.');
		}
	};

	const handleNextField = (index: number) => {
		if (index === 5) {
			handleSubmit();
			return;
		}

		const fields = [
			'firstName',
			'lastName',
			'email',
			'password',
			'confirmPassword',
		];

		document.getElementById(fields[index])?.focus();
	};

	const validatePassword = () => {
		const regEx =
			// eslint-disable-next-line no-useless-escape
			/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_]).{8,}$/;
		if (!regEx.test(account.password)) {
			setErrorRegex(true);
			return false;
		}
		setErrorRegex(false);
		return true;
	};

	const checkFields = () => {
		const { email, password } = account;

		if (
			email &&
			password &&
			confirmationPassword === account.password &&
			validatePassword()
		) {
			return true;
		}
		return false;
	};

	const handleSubmit = async () => {
		if (checkFields()) {
			const { email, password } = account;

			try {
				setLoading(true);

				await Auth.signUp({
					username: email,
					password,
					attributes: {
						'custom:preferredGroupName': 'Main',
						email,
					},
				});
				Analytics.track('register', 'Password Created', {
					email,
				});
				navigate(
					`/verification-code?token=${window.btoa(
						JSON.stringify({
							email: email,
							type: 'confirmation',
						}),
					)}`,
				);
			} catch (code: any) {
				Analytics.track('register', 'Error Password Created', {
					email,
				});
				loggerInfo({
					data: code,
					context: 'login',
					location: 'SignUp',
				});
				handleError(code);
				setLoading(false);
			}
		} else {
			setError(true);
		}
	};

	return {
		account,
		confirmationPassword,
		isLoading,
		hasError,
		hasErrorRegex,
		navigate,
		setConfirmationPassword,
		setAccount,
		handleNextField,
		handleSubmit,
	};
};
